import React from 'react';

import classes from './shop-detail-home.module.scss';
import 'swiper/css';
import 'swiper/css/scrollbar';
import Image from 'next/image';
import { IImage } from '@/schema/image';

function ShopDetailPromotion({ missionImages }: { missionImages: IImage[] }) {
  return (
    <div className={classes.detailPromotionGroup}>
      <div className={classes.detailIntroduceGroup}>
        {missionImages &&
          missionImages.length > 0 &&
          missionImages.map((image: IImage) => (
            <Image
              key={`mission-image-${image.url.split('/').pop()}`}
              src={image.url}
              alt={`promotion`}
              width={image.width}
              height={image.height}
            />
          ))}
      </div>
    </div>
  );
}

export default ShopDetailPromotion;
